import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FOTOVRAGENSET, NORMALEVRAGENSET} from '../../../game-data';

@Component({
  selector: 'sg-vraag-content',
  templateUrl: './vraag-content.component.html',
  styleUrls: ['./vraag-content.component.scss']
})
export class VraagContentComponent {

  @Input() vraagSoort: string;
  @Input() randomWelkeVraag: number;
  @Input() randomWelkeFotovraag: number;
  @Output() vraagContentChange = new EventEmitter();

  normaleVragenSet = NORMALEVRAGENSET;
  fotoVragenSet = FOTOVRAGENSET;

  closePopover() {
    this.vraagContentChange.emit(null);
  }
}
